import React from 'react'
import { Tooltip } from 'components'

const Hyphen = ({ text = 'Not Available' }) => {
  return (
    <Tooltip text={text}>
      <span>{' - '}</span>
    </Tooltip>
  )
}

export default Hyphen
